<template>
    <div>
        <v-card 
            class="mx-auto mb-4" 
            variant="outlined" 
            style="background-color: white;"
        >
            <div class="d-flex justify-space-between align-start pa-2 pb-2">
                <div class="text-subtitle-1 font-weight-bold text-truncate">
                    <v-chip
                        :color="statusDueDate(item).color"
                        label
                        small
                        class="overline"
                    >
                        {{ statusDueDate(item).description }}
                    </v-chip>
                </div>
                <div class="text-subtitle-1 text-truncate">
                    <span class="ml-4 font-weight-bold">TOTAL R$: {{ setTotal(item.json_account_values) }}</span>
                </div>
            </div>

            <div class="d-flex justify-space-between align-start pa-3 pb-2">
                <div class="caption text-truncate">
                    <span>DT VENC.: {{ formatDate(item.due_date) }}</span>
                </div>
                <div class="caption text-truncate">
                    <span>DT PGTO.: {{ formatDate(item.payment_date) }}</span>
                </div>
            </div>

            <v-divider class="mx-4 my-0"></v-divider>

          

            <v-card-actions class="d-flex pa-4 bg-grey-lighten-5 justify-end">
                <span v-if="item.bank_slips && item.bank_slips.length > 0">
                    <span v-if="item.bank_slips[0].pix">
                    
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-if="item.bank_slips[0].pix && item.bank_slips[0].pix != ''"
                                    class="ml-4"
                                    fab
                                    small
                                    target="blank"
                                    left 
                                    v-bind="attrs" 
                                    v-on="on"
                                    @click="dialogPix(item.bank_slips[0])"           
                                >
                                    <v-icon large>$pix</v-icon>
                                </v-btn>
                            </template>
                            <span>Copiar pix</span>
                        </v-tooltip>
                        
                        
                        
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-if="item.bank_slips[0].pix && item.bank_slips[0].pix != '' && item.bank_slips[0].linhaDigitavel != ''"
                                    class="ml-4"
                                    fab
                                    small
                                    target="blank"
                                    left 
                                    v-bind="attrs" 
                                    v-on="on"
                                    @click="copyLink(item.bank_slips[0].linhaDigitavel, 'Código barras copiado')"     
                                >
                                    <v-icon>
                                        mdi-barcode-scan
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Copiar codigo de barras</span>
                        </v-tooltip>
                    </span>
                
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="item.bank_slips && item.bank_slips.length > 0"
                                class="ml-4"
                                fab
                                small
                                target="blank"
                                :href="item.bank_slips[0].linkBoleto"
                                left 
                                v-bind="attrs" 
                                v-on="on"
                            >
                                <v-icon>
                                    mdi-download-circle-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Baixar boleto</span>
                    </v-tooltip>
                </span>

                <span v-else>
                    <v-btn
                        v-if="item.payment_date == null"
                        dark
                        color="purple"
                        :class="$css_button"
                        outlined
                        @click="storeBankSlip(item.id)"
                    >
                        Gerar boleto
                    </v-btn>
                </span>



            </v-card-actions>  
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'MobileAccountCard',

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },    

    methods: {
        setTotal(json){
            let total = 0
            if(json && json.length > 0){
                json.forEach(model => {
                    if(model.type == 'Crédito'){
                        total += model.value 
                    }
                })
            }
            return total
        },

        copyLink(item, msg){
            this.$emit('callCopyLink', item, msg);
        },

        dialogPix(item){
            this.$emit('callDialogPix', item);
        },

        storeBankSlip(id){
            this.$emit('callStoreBankSlip', id);
        },
    }
}   
</script>